import { OnInit } from '@angular/core';
var OccurrenceCommentReadByComponent = /** @class */ (function () {
    function OccurrenceCommentReadByComponent() {
    }
    OccurrenceCommentReadByComponent.prototype.ngOnInit = function () {
    };
    return OccurrenceCommentReadByComponent;
}());
export { OccurrenceCommentReadByComponent };
